import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg text-left text-textPrimary" }, "Evidência do registro de plantão", -1)
const _hoisted_2 = { class: "flex flex-col lg:flex-row gap-6 h-full" }
const _hoisted_3 = { class: "flex-1 min-w-0 flex flex-col gap-3" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-xl text-textPrimary bg-gray-200 py-1 px-2 rounded-lg"
}
const _hoisted_6 = { class: "text-xl font-semibold text-textPrimary truncate" }
const _hoisted_7 = { class: "w-full lg:w-[280px] flex flex-col gap-4 shrink-0" }
const _hoisted_8 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold leading-6 tracking-[0.08px] text-[#16161D]" }, " Responsável pelo envio ", -1)
const _hoisted_10 = { class: "text-sm text-textPrimary" }
const _hoisted_11 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold leading-6 tracking-[0.08px] text-[#16161D]" }, " Modalidade de registro ", -1)
const _hoisted_13 = { class: "text-sm text-textPrimary" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col gap-1 text-left"
}
const _hoisted_15 = { class: "text-base font-bold leading-6 tracking-[0.08px] text-[#16161D]" }
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "truncate" }
const _hoisted_19 = { class: "flex justify-end" }

import { ref, computed, watch } from 'vue'
import { mdiOpenInNew, mdiFile } from '@mdi/js'
import Modal from '@/components/designSystem/modals/Modal.vue'
import StepPreview from '@/components/designSystem/modals/AttendanceUploadModal/StepPreview.vue'
import type { HistoryEvent } from '@/components/designSystem/Cards/DsAttendanceHistoryCard.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  DSAttendanceStatus,
  EXTERNAL_APP_LABELS,
  ExternalApp
} from '@/constants/ds-attendance.constants'
import { ExceptionStatusEnum } from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import type { CheckEvidence } from '@/Network/Types/Requests/StationRequests'


export default /*#__PURE__*/_defineComponent({
  __name: 'EvidenceModal',
  props: {
    isOpen: { type: Boolean },
    id: {},
    fileName: {},
    file: {},
    fileUrl: {},
    files: {},
    uploader: {},
    monitoringType: {},
    sourceApp: {},
    status: {},
    historyEvents: {}
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit }) {

const props = __props;





const rotation = ref(0)
const zoom = ref(1)
const selectedIndex = ref(0)

watch(
  () => props.isOpen,
  (open) => {
    if (open) {
      selectedIndex.value = 0
      rotation.value = 0
      zoom.value = 1
    }
  }
)

// `sourceApp` chega cru do backend (`DOCTOR_ID`, `PEGA_PLANTAO`) e era concatenado
// sem tradução, vazando o enum na tela. `EXTERNAL_APP_LABELS` já existia para isso.
// Não usamos `formatMonitoringTypeLabel` porque ela só anexa o app quando
// `monitoringType === 'EXTERNAL_APP'`, e aqui a prop já chega traduzida.
const monitoringTypeLabel = computed(() => {
  const base = props.monitoringType || 'Não identificado'
  if (!props.sourceApp) return base
  const appLabel = EXTERNAL_APP_LABELS[props.sourceApp as ExternalApp] ?? props.sourceApp
  return `${base} - ${appLabel}`
})

const currentFile = computed(() => props.files[selectedIndex.value] ?? null)

const currentFileUrl = computed(() => {
  if (currentFile.value) return currentFile.value.path
  return props.fileUrl
})

const currentFileType = computed(() => currentFile.value?.type)

function selectFile(index: number) {
  selectedIndex.value = index
  rotation.value = 0
  zoom.value = 1
}

const openRegistry = () => {
  const url = currentFile.value?.path
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.isOpen,
    "has-header-border": true,
    "has-footer-border": true,
    "max-width": "max-w-6xl",
    "max-height": "90vh",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:isOpen', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(OutlineButton, {
          "data-testid": "evidence-close-button",
          text: "Fechar",
          width: "100px",
          height: "32px",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:isOpen', false)))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.id), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, _toDisplayString(currentFile.value?.name ?? _ctx.fileName), 1),
            _createVNode(OutlineButton, {
              text: "Ver registro",
              width: "160px",
              "prepend-icon": _unref(mdiOpenInNew),
              class: "ml-auto",
              height: "32px",
              onClick: openRegistry
            }, null, 8, ["prepend-icon"])
          ]),
          _createVNode(StepPreview, {
            file: _ctx.file,
            "file-url": currentFileUrl.value,
            "file-type": currentFileType.value,
            rotation: rotation.value,
            zoom: zoom.value,
            mode: "preview",
            "onUpdate:rotation": _cache[0] || (_cache[0] = ($event: any) => (rotation.value = $event)),
            "onUpdate:zoom": _cache[1] || (_cache[1] = ($event: any) => (zoom.value = $event)),
            "show-display-name": false
          }, null, 8, ["file", "file-url", "file-type", "rotation", "zoom"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.uploader || 'Não identificado'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(monitoringTypeLabel.value), 1)
          ]),
          (_ctx.files.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, " Arquivos (" + _toDisplayString(_ctx.files.length) + ") ", 1),
                _createElementVNode("ul", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (evidenceFile, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: evidenceFile.path,
                      class: _normalizeClass(["flex items-center gap-2 py-1.5 px-2 rounded-lg cursor-pointer text-sm transition-colors", 
                index === selectedIndex.value
                  ? 'bg-primary30 text-white font-semibold'
                  : 'hover:bg-gray-100 text-textPrimary'
              ]),
                      "data-testid": "evidence-file-item",
                      onClick: ($event: any) => (selectFile(index))
                    }, [
                      _createVNode(_component_v_icon, {
                        icon: _unref(mdiFile),
                        size: "16"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(evidenceFile.name), 1)
                    ], 10, _hoisted_17))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})